import React from "react"
import { Navigate } from "react-router-dom"
import useUserProfile from "../components/hooks/profile/useUserProfile";

export interface PrivateRouteProps {
  element: JSX.Element
}

const PrivateRoute = ({ element }: PrivateRouteProps): JSX.Element => {

  const { profile, isLoading } = useUserProfile()

  if (isLoading) {
    return <></>
  }

  return profile?.user?.id ? element : <Navigate to="/login" />
}

export default PrivateRoute
